import { useState } from "react"

export const useGlobalStates = () => {
    
    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [componentModalDeposit, setComponentModalDeposit ] = useState('')

    //generales
    const [stepApplilication, setStepApplilication] = useState(0)

    // para formulario
    const [showForm, setShowForm ] = useState(false)
    const [showExpenses, setShowExpenses ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')

    // para drop down
    const [anchorEl, setAnchorEl] = useState(null); // Para el elemento de anclaje


    return Object.freeze({
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        componentModalDeposit, setComponentModalDeposit,
        stepApplilication, setStepApplilication,
        formOpeningMode, setFormOpeningMode,
        showExpenses, setShowExpenses,
        showForm, setShowForm,
        anchorEl, setAnchorEl,
    })
}